import { DIS } from '@typings/dis';

export const isClubRotaractSatellite = (clubType: string) =>
  clubType === DIS.ClubTypeEnum.RotaractSatelliteClub;
